import { render } from "./HalamanTabelKomisi.vue?vue&type=template&id=a97c903c&scoped=true"
import script from "./HalamanTabelKomisi.vue?vue&type=script&lang=js"
export * from "./HalamanTabelKomisi.vue?vue&type=script&lang=js"

import "./HalamanTabelKomisi.vue?vue&type=style&index=0&id=a97c903c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a97c903c"]])

export default __exports__